import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { useNavigate } from 'react-router-dom'
import config from "../../config"
import axios from "axios";
import Swal from 'sweetalert2'
import Moment from 'react-moment';

const My_referrals = () => {
    const[state,setState] = React.useState([])
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
React.useEffect(()=>{
    getReferrals()
},[])
    const getReferrals=()=>{
        let dataToSend = {customer_id : userData.customer_id , jp_id:userData.jp_id};
       
         // console.log("datatoSend",dataToSend)
         let url = config.apiUrl + '/user/get_my_refferals';
         axios.post(url, dataToSend, { headers: config.headers })
             .then((res) => {
               // console.log("responseJson => ", res);
               if(res.data.status==true){
                setState(res.data.output)
        }
       else{
           const Toast = Swal.mixin({
               toast: true,
               position: 'bottom-end',
               showConfirmButton: false,
               timer: 3000
             })
             Toast.fire({
               background:"#a61c09",
               type: 'Unsuccess',
               title: "Something Went Wrong !",
               color:"white"
             });
       } })
           
             .catch((error) => {
               const Toast = Swal.mixin({
                   toast: true,
                   position: 'bottom-end',
                   showConfirmButton: false,
                   timer: 3000
                 })
                 Toast.fire({
                   background:"#a61c09",
                   type: 'Unsuccess',
                   title: "Something Went Wrong !",
                   color:"white"
                 });
                 // console.log(error);
             });    
       
       }
  return (
    <div>
         <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"></div>
      <div class="mob_nav">
  <div class=" d-flex justify-content-start ">
    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
    <h2>My Referrals</h2>
  </div>
</div>


<div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>My Referrals</h2>
      </div>
    </div>
</div>



<div class="card border-0 my_referrals mb-3">
  <div class="card-body">
    <div class="row">
        <div class="col-12 col-md-6">
          <img src="https://i.imgur.com/Opj7OpK.png" class="img-fluid" />
        </div>
        <div class="col-12 col-md-6 margin_top">
          <h2>Earn flat INR 1 on every eligible order referred by you*</h2>
          <h2>To refer, ask your friend to signup using your JP ID shown below</h2>

          <div>
            <h1>{userData.jp_id?userData.jp_id:""} <a onClick={(e) => {
      e.preventDefault();  // Prevents page reload
      navigator.clipboard.writeText(userData.jp_id);
       const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000
            })
            Toast.fire({
              background:"#a61c09",
              type: 'success',
              title: "JP ID copied!",
              color:"white"
            });
      // alert("JP ID copied!");  // Optional: Show an alert
    }} data-bs-toggle="tooltip" title="Copy JP ID" style={{ cursor: "pointer" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16"  style={{height:"50px" , width:"auto"}}>
    <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
  </svg></a></h1>
          </div>
        </div>
    </div>
    <small>*Eligible orders are delivered ordres costing more than INR 100, exclusive of taxes</small>
  </div>
</div>

<div class="card border-0">
  <div class="card-body">
    <table class="table table-bordered">
        <thead>
          <tr>
            <th>Sr No</th>
            <th>Client Name</th>
            <th>Referral Date</th>
          </tr>
        </thead>
        <tbody>
            {state.map((sub , index)=>(
          <tr>
            <td>{index+1}</td>
            <td>{sub.full_name}</td>
            <td><Moment format="YYYY-MM-DD  hh:mm:ss a">
                         {new Date(sub.created*1000)}
             </Moment></td>
          </tr>
          ))}
         
        </tbody>
      </table>
  </div>
</div>
    </div>
    <Footer/></div></div></div>
    </div>
  )
}

export default My_referrals
